import React from 'react';
import logo from '@/assets/logo.png';

/**
 * LogoMark — the freed circular IT-WELT360 emblem with an animated glow
 * and an optional rotating light ring for a premium "wow" feel.
 */
export function LogoMark({ size = 44, ring = false, glow = true, className = '' }) {
  return (
    <div className={`relative shrink-0 ${className}`} style={{ width: size, height: size }}>
      {glow && (
        <div className="absolute inset-0 rounded-full blur-md logo-glow-pulse"
          style={{ background: 'radial-gradient(circle, rgba(0,231,255,0.55), transparent 62%)' }} />
      )}
      {ring && (
        <div className="absolute -inset-[7%] rounded-full logo-spin-ring"
          style={{
            background: 'conic-gradient(from 0deg, transparent 0deg, #5AF3FF 55deg, #00E7FF 90deg, transparent 150deg, transparent 360deg)',
            WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 2.5px))',
            mask: 'radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 2.5px))',
          }} />
      )}
      <img src={logo} alt="IT-WELT360" className="relative w-full h-full object-contain"
        style={{ filter: 'drop-shadow(0 2px 10px rgba(0,231,255,0.28))' }} draggable={false} />
    </div>
  );
}

export default LogoMark;
